<template>
    <div @click="handleClick" class="tab"> <span>{{ text }} </span></div>
</template>

<script>
	export default {
        name: "tab",
        props: ['text', 'handleClick']
	}

</script>

<style lang="scss" scoped>

	div.tab {
        display: inline-block;
        height: 50px; width: 50%;
        text-align: center;
        line-height: 48px;
        color: #4a4a4a;
        background-color: #d8d8d8;
        font-size: 24px;
        vertical-align: top;
        border-bottom: solid 5px #f7f7f7;
        span { opacity: 0.5; }
        &[data-selected="true"] {
            height: 50px;
            border-bottom: solid 5px #d8d8d8;
            span { opacity: 1; }
        }
        &[data-right] {
            background-color: #f7f7f7;
            border-bottom: solid 5px #d8d8d8;
            &[data-selected="true"] {
                border-bottom: solid 5px #f7f7f7;
            }
        }
	}

</style>



// WEBPACK FOOTER //
// src/components/ui/nav/Tab.vue